import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const BrokerProfile = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    } else {
      navigate("/log-in"); // redirect if not logged in
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("authToken");
    navigate("/log-in");
  };

  if (!user) return null;

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 py-10 px-4">
      <div className="max-w-4xl mx-auto bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8">
        <h1 className="text-3xl font-bold text-center text-purple-600 mb-6">
          Broker Profile
        </h1>

        {/* User Details in Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm text-left text-gray-700 dark:text-gray-200">
            <tbody>
              {Object.entries(user).map(([key, value]) => (
                <tr key={key} className="border-b border-gray-200 dark:border-gray-700">
                  <td className="px-4 py-2 font-semibold capitalize">
                    {key.replace(/_/g, " ")}
                  </td>
                  <td className="px-4 py-2">
                    {value === null || value === "" ? "—" : value.toString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Logout */}
        <div className="mt-8 text-center">
          <button
            onClick={handleLogout}
            className="px-6 py-2 rounded-lg bg-red-600 text-white font-medium hover:bg-red-700 transition"
          >
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default BrokerProfile;
